import { sortBy } from "lodash";
import { BasicUser } from "types/topicflow";

export type ReopenableReview = {
  id: number;
  responder?: BasicUser | null;
  responderName?: string | null;
};

export const isAnonymous = (review: ReopenableReview) =>
  !review.responder && !review.responderName;

/**
 * The number each anonymous review shows in a Reopen menu, by review id.
 * Only the reviews without a writer's name take a number, in id order.
 * A reopened review is not submitted, so it leaves the list and the later reviews move up
 * one number until it is submitted again. The submit date in the label tells them apart.
 * Pass every submitted review of one type for one person, so both Reopen menus agree.
 */
export const numberAnonymousReviews = (reviews: ReopenableReview[]) =>
  new Map(
    sortBy(reviews.filter(isAnonymous), "id").map(({ id }, index) => [
      id,
      index + 1,
    ]),
  );
